import { render } from "./newTMbulkImport.vue?vue&type=template&id=2e32bf0d&scoped=true"
import script from "./newTMbulkImport.vue?vue&type=script&lang=js"
export * from "./newTMbulkImport.vue?vue&type=script&lang=js"

import "./newTMbulkImport.vue?vue&type=style&index=0&id=2e32bf0d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e32bf0d"]])

export default __exports__